// You can write your custom Javascript here

// Collection ajax load more
jQuery(document).ready(function () {
  function init() {
    if (!document.querySelector(".js-loadmore")) {
      return;
    }
    addEventListener();
    onload();
  }

  var cpHeight = jQuery(".product-item .product__images").height();
  jQuery(
    ".featured-item--large .featured-item__videoContainer .featured-item__video"
  ).css("height", cpHeight + "px");

  jQuery(window).resize(function () {
    var cpHeight = jQuery(".product-item .product__images").height();
    jQuery(
      ".featured-item--large .featured-item__videoContainer .featured-item__video"
    ).css("height", cpHeight + "px");
  });

  jQuery(window).trigger("resize");

  function loadmore(event) {
    event.preventDefault();

    var url = getProductUrl(event);
    console.log('[loadmore] url: ', url);
    jQuery.ajax({
      type: "GET",
      url: url,
      data: {},
      success: function (data) {
        var grid = jQuery(data).find(".product-items > ul").children();
        $(".product-items > ul").append(grid);
        updateUrl(data);
        updateButtonUrl(data);
        lazyLoadInitFn();
        hide_leftover_pcard();

      },
    });
  }


  function hide_leftover_pcard() {
      $('.leftover_to_hide').removeClass('leftover_to_hide');
      var lastChild = $('.product-items > ul > li').last();
      var parentDiv = $('.product-items > ul');
      var pcard_num_on_row;
      if (window.innerWidth > 1020) {
        pcard_num_on_row = 4;
      } else {
        pcard_num_on_row = 2;
      }
      console.log("lastChild", lastChild);
      var leftover_count = ((lastChild.offset().left - parentDiv.offset().left) / lastChild.outerWidth() + 1) % pcard_num_on_row;
      if (leftover_count > 0 && $('.button.js-loadmore').hasClass('is-hidden') == false) {
        $('.product-items > ul > li:gt(-' + (leftover_count + 1) + ')').addClass('leftover_to_hide');
      }
  }
  
  hide_leftover_pcard();

  function updateUrl(data) {
    var gridData = jQuery(data).find(".js-collection-products")[0].dataset.paginateCurrent;
    var pageNumber = getParameterByName("page", gridData);
    var newurl =
      window.location.protocol +
      "//" +
      window.location.host +
      window.location.pathname +
      "?page=" +
      pageNumber;
    window.history.pushState({ path: newurl }, "", newurl);
  }

  function updateButtonUrl(data) {
    var button = document.querySelector(".js-loadmore");
    var btt = document.querySelector(".js-btt");
    var pageNext = jQuery(data).find(".js-collection-products")[0].dataset.paginateNext;
    var pageCurrent = jQuery(data).find(".js-collection-products")[0].dataset.paginateCurrent;
    var pageCurrent = getParameterByName("page", pageCurrent);
    var pageMax = jQuery(data).find(".js-collection-products")[0].dataset.paginateMax;
    if (pageCurrent == pageMax) {
      button.classList.add("is-hidden");
      btt.classList.remove("js-back-to-top");
      btt.classList.add("js-back-to-top-last");
    } else {
      button.classList.remove("is-hidden");
      btt.classList.add("js-back-to-top");
      btt.classList.remove("js-back-to-top-last");
    }

    button.dataset.paginate = pageNext;
  }

  function addEventListener(event) {
    jQuery(".js-loadmore").on("click", function (event) {
      loadmore(event);
    });

    jQuery(".js-back-to-top").on("click", function (event) {
      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    });

    jQuery(".load-more-container").on(
      "click",
      ".js-back-to-top-last",
      function () {
        window.scroll({
          top: 0,
          left: 0,
          behavior: "smooth",
        });

        window.history.replaceState(null, null, window.location.pathname);
      }
    );
  }

  function getParameterByName(name, url) {
    console.log('url:', url);
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  function getProductUrl(event) {
    return event.target.dataset.paginate;
  }

  function onload() {
    var url = window.location.href;
    var page = getParameterByName("page", url);
    var pageInt = parseInt(page);
    var container = document.querySelector(".js-collection-products");
    var basicUrl = container.dataset.paginateBasic;
    var urlArray = [];

    for (var i = pageInt - 1; i >= 0; i--) {
      var pageCount = i + 1;
      if (pageCount != pageInt) {
        var url = basicUrl + pageCount;
        urlArray.push(url);
      }
    }

    premendload(urlArray);
  }

  function premendload(url) {
    // array of page urls
    var pages = url;

    // the recursive function
    function getRecursive() {
      // terminate if array exhausted
      if (pages.length === 0) return;

      // pop top value
      var id = pages[0];
      pages.shift();

      jQuery.ajax({
        type: "GET",
        url: id,
        data: {},
        success: function (data) {
          var grid = jQuery(data).find(".js-collection-products");
          var gridHtml = grid.html();
          jQuery(".js-collection-products").prepend(gridHtml);
          lazyLoadInitFn()
          getRecursive();
        },
      });
    }

    // fires off the first call
    getRecursive();
  }

  init();
});

function lazyLoadInitFn(){
  var lazyloadImages;

  if ("IntersectionObserver" in window) {
    lazyloadImages = document.querySelectorAll(".lazy");
    var imageObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var image = entry.target;
          image.classList.remove("lazy");
          imageObserver.unobserve(image);
        }
      });
    });

    lazyloadImages.forEach(function(image) {
      imageObserver.observe(image);
    });
  } else {
    var lazyloadThrottleTimeout;
    lazyloadImages = document.querySelectorAll(".lazy");

    function lazyload () {
      if(lazyloadThrottleTimeout) {
        clearTimeout(lazyloadThrottleTimeout);
      }

      lazyloadThrottleTimeout = setTimeout(function() {
        var scrollTop = window.pageYOffset;
        lazyloadImages.forEach(function(img) {
            if(img.offsetTop < (window.innerHeight + scrollTop)) {
              img.src = img.dataset.src;
              img.classList.remove('lazy');
            }
        });
        if(lazyloadImages.length == 0) {
          document.removeEventListener("scroll", lazyload);
          window.removeEventListener("resize", lazyload);
          window.removeEventListener("orientationChange", lazyload);
        }
      }, 20);
    }

    document.addEventListener("scroll", lazyload);
    window.addEventListener("resize", lazyload);
    window.addEventListener("orientationChange", lazyload);
  }
}

// Reviews toggle
jQuery(document).ready(function () {
  // const toggleReviews = jQuery('.js-toggle-reviews');

  // toggleReviews.on('click', function() {
  //   const reviews = jQuery('.yotpo-reviews');

  //   if (reviews.hasClass('is-active')) {
  //     reviews.removeClass('is-active');
  //     toggleReviews.val('Read More')
  //   } else {
  //     reviews.addClass('is-active');
  //     toggleReviews.val('Read Less')
  //   }
  // });

  // function reviewsCount() {
  //   const $reviewsCount  = jQuery('.total-reviews-search').attr('total-reviews-search');
  //   const reviewsCountInt = parseInt($reviewsCount);

  //   if (reviewsCountInt <= 1 ) {
  //     reviewsHideReadMore()
  //   }
  // };

  // function reviewsHideReadMore() {
  //   jQuery('.yotpo-split-button-container .btn-large').hide();
  // };

  // setTimeout(() => {
  //   if (jQuery('.main-widget.yotpo-display-wrapper').hasClass('yotpo-no-reviews')) {
  //     jQuery('.js-main-widget').hide()
  //     jQuery('.js-shoppers-say').show()
  //   } else {
  //     reviewsCount();
  //   }
  // }, 1000);

  jQuery('.slide-to').on('mouseover', function(event) {
    event.preventDefault();

    if (jQuery(this).hasClass('product__head-review--no-hover')) {
      return;
    }

    if (jQuery(event.target).find('.sr-only').text().includes("0.0 star rating")) {
      jQuery(this).addClass('product__head-review--no-hover');
      return;
    }
  });

  jQuery('.slide-to').on('click', function(event) {
    event.preventDefault();

    if (jQuery(this).hasClass('product__head-review--no-hover')) {
      return;
    }

    const slideLink = jQuery(this).attr('data-slide');

    jQuery('html, body').animate({
      scrollTop: jQuery(slideLink).offset().top - 200,
    }, 1500);
  });

})

jQuery(document).ready(function () {

  let observer = new MutationObserver(log);

  function log(mutations) {
    for (let mutation of mutations) {
      if (mutation.type === 'childList') {
        yoptoEmpty();
      }
    }
  }

  let yoptoElem = document.querySelector('.product__head-review');

  observer.observe(yoptoElem, {
    childList: true,
    subtree: true
  });

  function yoptoEmpty() {
    console.log(`👑 The king is back`)
    console.log(`👑 The king is back`)
    console.log(`👑 The king is back`)

    console.log(`🔮 The future is beautiful!`)
    const container = jQuery('.product__head-review');

    if (container.find('.sr-only').text().includes("0.0")) {
      observer.disconnect();
    } else {
      container.addClass('product__head-review--block');
      observer.disconnect();
    };
  }
})

// Signup form
jQuery(document).ready(function () {
  function setCookie(cname,cvalue,exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires=" + d.toGMTString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  jQuery(".popup__content .form__btn").on("click", function(event) {
    event.preventDefault();

    formSubmit(jQuery('#Email-Popup'), 'Modal');
  });

  jQuery( ".newsletter.footer__newsletter .form__btn" ).on( "click", function(event) {
    event.preventDefault();

    formSubmit(jQuery('#Email-Footer'), 'Footer');
  });

  function formSubmit(emailTarget, source) {
    var email = emailTarget.val();
    var settings = {
      "async": true,
      "crossDomain": true,
      "url": "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
      "method": "POST",
      "headers": {
        "content-type": "application/x-www-form-urlencoded",
        "cache-control": "no-cache"
      },
      "data": {
        "g": "X5gpVr",
        "$fields": "$source",
        "email": email,
        "$source": source,
      }
    };

    if (validateEmail(email)) {
      jQuery.ajax(settings).done(function (response) {
        if(response.success === true) {
          setCookie("newsletter_popup_closed", true, 10);
          window.location.assign("/pages/thank-you");
        } else {
          jQuery( ".newsletter.footer__newsletter .success-response" ).hide();
          jQuery( ".newsletter.footer__newsletter .error-response" ).text('Something seems to have gone wrong. Please try again shortly.').show();
        }
      });
    } else {
      jQuery( ".newsletter.footer__newsletter .error-response" ).text('Please enter a valid email address.').show();
    }
  }

  function validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }
})


// Lazy load backgorund images
document.addEventListener("DOMContentLoaded", function() {
  lazyLoadInitFn()
})

window.addEventListener('images-layout-ready', () => {
  jQuery('.js-images-layout').removeClass('opacity-hidden')
  lazyLoadInitFn()
})
